import * as React from 'react'
import { useTranslation } from '~/hooks/useTranslation'

export function ServiceTypeCell({ row }) {
  const { t } = useTranslation('ServiceTypeCell')
  const feedback = row.original
  const typeMap = {
    'ServiceRequest::ResumeReview': 'resume',
    'ServiceRequest::OrientationCall': 'orientation',
    'ServiceRequest::CareerConsultationCall': 'career',
    'ServiceRequest::CareerPivotPlanning': 'career_pivot',
    'ServiceRequest::LinkedInReview': 'linked_in',
  }

  const formatServiceRequestType = (type) => {
    const prefixRemoved = type.replace('ServiceRequest::', '')
    for (let i = 0; i < prefixRemoved.length; i++) {
      if (prefixRemoved[i] === prefixRemoved[i].toUpperCase()) {
        return (
          prefixRemoved.slice(0, i) + ' ' + prefixRemoved.slice(i).toLowerCase()
        )
      }
    }
    return prefixRemoved
  }

  const serviceTypeText = typeMap[feedback.type]
    ? t(typeMap[feedback.type])
    : formatServiceRequestType(feedback.type)

  return (
    <div className="flex flex-col gap-1 pr-2">
      <div className="text-normal line-clamp-1 font-bold">
        {serviceTypeText}
      </div>
    </div>
  )
}
